/* =========================================================
   CLUB ORIGINS — theme.js
   Lógica de conversión: carrito AJAX + drawer, upsell, urgencia,
   fecha de entrega, cuenta atrás de envío, galería, vídeos,
   pop-up de ventas, sticky add-to-cart, bundles.
   ========================================================= */
(function () {
  'use strict';
  const T = window.theme || {};
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ---------- Utilidades ---------- */
  function formatMoney(cents) {
    const fmt = T.moneyFormat || '{{amount_with_comma_separator}} €';
    const value = (cents / 100);
    let amount;
    if (fmt.indexOf('comma_separator') > -1) {
      amount = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else if (fmt.indexOf('no_decimals') > -1) {
      amount = Math.round(value).toString();
    } else {
      amount = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }
  window.formatMoney = formatMoney;

  function toast(msg) {
    let el = $('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; document.body.appendChild(el); }
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(el._t); el._t = setTimeout(() => el.classList.remove('is-visible'), 2200);
  }

  const LANG = (document.documentElement.lang || 'es').toLowerCase();
  const fmt = (d, opts) => { try { return new Intl.DateTimeFormat(LANG, opts).format(d); } catch (e) { return d.toLocaleDateString(); } };
  const weekdayDay = d => (LANG.startsWith('es') ? 'el ' : '') + fmt(d, { weekday: 'long', day: 'numeric' });
  const dayMonth = d => fmt(d, { day: 'numeric', month: 'long' });

  function addBusinessDays(date, n) {
    const d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  }
  function startDate() {
    // día en que empieza la preparación: hoy si es laborable y antes de la hora límite
    const now = new Date();
    let d = new Date(now);
    const cutoff = Number(T.shippingCutoffHour || 14);
    if (now.getHours() >= cutoff || d.getDay() === 0 || d.getDay() === 6) d = addBusinessDays(d, 1);
    return d;
  }
  function addDays(date, n) { const d = new Date(date); d.setDate(d.getDate() + n); return d; }
  function rangeText(a, b) {
    const sameMonth = a.getMonth() === b.getMonth();
    if (sameMonth) return `${a.getDate()}–${dayMonth(b)}`;
    return `${dayMonth(a)} – ${dayMonth(b)}`;
  }

  /* ---------- Fecha de entrega + cuenta atrás ---------- */
  function initDelivery() {
    const pMin = Number(T.processingMinDays ?? 1), pMax = Number(T.processingMaxDays ?? 3);
    const sMin = Number(T.shippingMinDays ?? 4), sMax = Number(T.shippingMaxDays ?? 7);
    const start = startDate();
    const shipMin = addBusinessDays(start, pMin), shipMax = addBusinessDays(start, pMax);
    const arriveMin = addDays(shipMin, sMin), arriveMax = addDays(shipMax, sMax);
    $$('[data-today]').forEach(el => { el.textContent = dayMonth(new Date()); });
    $$('[data-delivery-range]').forEach(el => { el.textContent = rangeText(arriveMin, arriveMax); });
    $$('[data-ship-range]').forEach(el => { el.textContent = rangeText(shipMin, shipMax); });
    $$('[data-arrive-range]').forEach(el => { el.textContent = rangeText(arriveMin, arriveMax); });
    const cds = $$('[data-cutoff-countdown]');
    if (!cds.length) return;
    function tick() {
      const now = new Date();
      const cutoff = Number(T.shippingCutoffHour || 14);
      let target = new Date(now); target.setHours(cutoff, 0, 0, 0);
      if (now >= target || target.getDay() === 0 || target.getDay() === 6) {
        target = addBusinessDays(target, 1); target.setHours(cutoff, 0, 0, 0);
      }
      let diff = Math.max(0, target - now);
      const h = Math.floor(diff / 36e5); diff -= h * 36e5;
      const m = Math.floor(diff / 6e4); diff -= m * 6e4;
      const s = Math.floor(diff / 1e3);
      cds.forEach(el => {
        if (el.dataset.cutoffCountdown === 'full') el.textContent = `${h} h ${String(m).padStart(2, '0')} min ${String(s).padStart(2, '0')} s`;
        else el.textContent = `${h} h ${String(m).padStart(2, '0')} min`;
      });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Cuenta atrás genérica (ofertas) ---------- */
  function initCountdowns() {
    $$('[data-countdown]').forEach(el => {
      let end;
      const raw = el.dataset.countdown;
      if (raw && raw !== 'daily') { end = new Date(raw); }
      if (!end || isNaN(end)) {
        // reinicio diario a medianoche → urgencia perpetua
        end = new Date(); end.setHours(23, 59, 59, 999);
      }
      const units = { d: $('[data-unit="d"]', el), h: $('[data-unit="h"]', el), m: $('[data-unit="m"]', el), s: $('[data-unit="s"]', el) };
      function tick() {
        let diff = Math.max(0, end - new Date());
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        if (units.d) units.d.textContent = String(d).padStart(2, '0');
        if (units.h) units.h.textContent = String(h).padStart(2, '0');
        if (units.m) units.m.textContent = String(m).padStart(2, '0');
        if (units.s) units.s.textContent = String(s).padStart(2, '0');
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- Personas viendo / vendidas ---------- */
  function initViewers() {
    $$('[data-viewers]').forEach(el => {
      const base = 12 + Math.floor(Math.random() * 20);
      let n = base;
      const render = () => { el.textContent = n; };
      render();
      setInterval(() => { n = Math.max(6, Math.min(48, n + (Math.random() > .5 ? 1 : -1))); render(); }, 7000 + Math.random() * 6000);
    });
  }

  /* ---------- Carrito ---------- */
  const Cart = {
    drawer: null,
    async fetch() { const r = await fetch(T.cartUrl + '.js', { headers: { Accept: 'application/json' } }); return r.json(); },
    async add(items) {
      const body = Array.isArray(items) ? { items } : { items: [items] };
      const r = await fetch(T.cartAddUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.description || e.message || 'Error'); }
      return r.json();
    },
    async change(line, quantity) {
      const r = await fetch(T.cartChangeUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      return r.json();
    },
    async refreshDrawer(open) {
      const drawer = $('#CartDrawer');
      const r = await fetch(T.rootUrl + '?section_id=cart-drawer');
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#CartDrawer');
      if (drawer && fresh) {
        drawer.querySelector('.cart-drawer__panel').innerHTML = fresh.querySelector('.cart-drawer__panel').innerHTML;
        bindCartUI(drawer);
      }
      const count = doc.querySelector('[data-cart-count-source]');
      if (count) $$('.cart-count').forEach(c => { c.textContent = count.textContent; c.dataset.count = count.textContent; });
      if (open && drawer) Cart.open();
      // refrescar página de carrito si estamos en ella
      const cartPage = $('[data-cart-page]');
      if (cartPage) {
        const rp = await fetch(location.pathname + '?section_id=main-cart');
        const doc2 = new DOMParser().parseFromString(await rp.text(), 'text/html');
        const freshPage = doc2.querySelector('[data-cart-page]');
        if (freshPage) { cartPage.innerHTML = freshPage.innerHTML; bindCartUI(cartPage); initUpsell(); }
      }
    },
    open() { const d = $('#CartDrawer'); if (d) { d.setAttribute('open', ''); document.body.style.overflow = 'hidden'; } },
    close() { const d = $('#CartDrawer'); if (d) { d.removeAttribute('open'); document.body.style.overflow = ''; } }
  };
  window.Cart = Cart;

  function bindCartUI(root) {
    $$('[data-cart-close]', root).forEach(b => b.addEventListener('click', Cart.close));
    $$('[data-line-qty]', root).forEach(wrap => {
      const line = Number(wrap.dataset.lineQty);
      const input = $('input', wrap);
      $$('button', wrap).forEach(b => b.addEventListener('click', async () => {
        let q = Number(input.value) + Number(b.dataset.delta);
        if (q < 0) q = 0;
        input.value = q;
        await Cart.change(line, q); Cart.refreshDrawer(false);
      }));
      input.addEventListener('change', async () => { await Cart.change(line, Number(input.value)); Cart.refreshDrawer(false); });
    });
    $$('[data-line-remove]', root).forEach(b => b.addEventListener('click', async e => {
      e.preventDefault(); await Cart.change(Number(b.dataset.lineRemove), 0); Cart.refreshDrawer(false);
    }));
    initUpsell(root);
    if (window.coCartEnhance) window.coCartEnhance(root);
  }

  function initUpsell(root) {
    $$('[data-upsell-add]', root || document).forEach(btn => {
      if (btn._bound) return; btn._bound = true;
      btn.addEventListener('click', async () => {
        const wrap = btn.closest('[data-upsell-item]');
        const sel = wrap && wrap.querySelector('select');
        const id = sel ? sel.value : btn.dataset.upsellAdd;
        btn.classList.add('is-loading'); btn.textContent = T.strings.adding;
        try { await Cart.add({ id: Number(id), quantity: 1 }); toast(T.strings.added); await Cart.refreshDrawer(true); }
        catch (err) { toast(err.message); }
        finally { btn.classList.remove('is-loading'); btn.textContent = 'Añadir'; }
      });
    });
  }

  function initCartTriggers() {
    $$('[data-cart-open]').forEach(b => b.addEventListener('click', e => { if (T.cartDrawer === false) return; e.preventDefault(); Cart.refreshDrawer(true); }));
    const d = $('#CartDrawer'); if (d) { $('.cart-drawer__overlay', d).addEventListener('click', Cart.close); bindCartUI(d); }
    document.addEventListener('keydown', e => { if (e.key === 'Escape') { Cart.close(); closeNav(); closeSearch(); } });
  }

  /* ---------- Formulario de producto ---------- */
  function initProductForms() {
    $$('form[data-product-form]').forEach(form => {
      const product = JSON.parse($('[data-product-json]', form.closest('[data-product]') || document).textContent);
      const idInput = $('input[name="id"]', form);
      const atc = $('[data-add-to-cart]', form);
      const buyNow = $('[data-buy-now]', form);
      const priceEl = $('[data-product-price]');
      const stickyPrice = $('[data-sticky-price]');
      const qtyInput = $('input[name="quantity"]', form);
      const bundleWrap = $('[data-bundle]', form.closest('[data-product]') || document);

      function selectedOptions() {
        return $$('fieldset[data-option-index]', form).map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
      }
      function currentVariant() {
        if (product.variants.length === 1) return product.variants[0];
        const opts = selectedOptions();
        return product.variants.find(v => v.options.every((o, i) => o === opts[i])) || (opts.every(o => o === null) ? product.variants.find(v => v.available) || product.variants[0] : undefined);
      }
      function renderPrice(v) {
        if (!priceEl || !v) return;
        const pct = v.compare_at_price && v.compare_at_price > v.price ? Math.floor((1 - v.price / v.compare_at_price) * 100) : 0;
        priceEl.innerHTML = `<span class="price__sale">${formatMoney(v.price)}</span>` +
          (pct ? `<span class="price__compare">${formatMoney(v.compare_at_price)}</span><span class="price__percent">-${pct}%</span>` : '');
        if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      }
      function updateStock(v) {
        const el = $('[data-variant-stock]');
        if (!el) return;
        const q = v && typeof v.inventory_quantity === 'number' ? v.inventory_quantity : null;
        const threshold = Number(el.dataset.threshold || 5);
        let show = false, n = 0;
        // Solo con inventario real de Shopify: nunca inventamos unidades
        if (v && v.inventory_management && q !== null && q > 0 && q <= threshold) { show = true; n = q; }
        el.hidden = !show;
        const num = $('[data-stock-number]', el); if (num) num.textContent = n;
        const bar = $('.stock-bar span', el); if (bar) bar.style.width = Math.max(8, Math.min(40, n * 8)) + '%';
      }
      function update() {
        const v = currentVariant();
        // marcar opciones no disponibles
        $$('fieldset[data-option-index]', form).forEach(fs => {
          const idx = Number(fs.dataset.optionIndex);
          const others = selectedOptions();
          $$('.variant-option', fs).forEach(opt => {
            const val = $('input', opt).value;
            const avail = product.variants.some(pv => pv.available && pv.options[idx] === val && pv.options.every((o, i) => i === idx || o === others[i]));
            opt.classList.toggle('is-unavailable', !avail);
          });
        });
        $$('[data-selected-value]', form).forEach(el => { const fs = el.closest('fieldset'); const c = $('input:checked', fs); el.textContent = c ? c.value : ''; });
        if (!v) { atc.disabled = true; atc.textContent = T.strings.unavailable; if (buyNow) buyNow.disabled = true; return; }
        idInput.value = v.id;
        renderPrice(v); updateStock(v);
        if (!v.available) { atc.disabled = true; atc.textContent = T.strings.soldOut; if (buyNow) buyNow.disabled = true; }
        else { atc.disabled = false; atc.textContent = atc.dataset.label || T.strings.addToCart; if (buyNow) buyNow.disabled = false; }
        if (bundleWrap) renderBundle(v);
        const url = new URL(location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      }
      $$('fieldset[data-option-index] input', form).forEach(i => i.addEventListener('change', update));

      /* bundles: 1 / 2 / 3 unidades con descuento por cantidad */
      let bundleQty = 1, bundleCode = '';
      async function applyDiscount(code) {
        if (!code) return;
        try { await fetch(T.rootUrl.replace(/\/$/, '') + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(T.cartUrl), { credentials: 'same-origin' }); } catch (e) { }
      }
      window.applyDiscount = applyDiscount;
      function renderBundle(v) {
        $$('.bundle__option', bundleWrap).forEach(opt => {
          const q = Number(opt.dataset.qty); const disc = Number(opt.dataset.discount || 0);
          const base = v.price * q; const total = Math.round(base * (1 - disc / 100));
          const unit = Math.round(total / q);
          $('[data-bundle-total]', opt).textContent = formatMoney(total);
          const cmp = $('[data-bundle-compare]', opt);
          if (cmp) { const c = (v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price) * q; cmp.textContent = c > total ? formatMoney(c) : ''; }
          const save = $('[data-bundle-save]', opt); if (save) save.textContent = disc ? `Ahorras ${formatMoney(base - total)} · ${formatMoney(unit)}/ud` : `${formatMoney(unit)}/ud`;
        });
      }
      if (bundleWrap) {
        $$('.bundle__option', bundleWrap).forEach(opt => opt.addEventListener('click', () => {
          $$('.bundle__option', bundleWrap).forEach(o => o.classList.remove('is-selected'));
          opt.classList.add('is-selected'); bundleQty = Number(opt.dataset.qty); bundleCode = opt.dataset.code || '';
          if (qtyInput) qtyInput.value = bundleQty;
        }));
      }

      async function submit(redirect) {
        const btn = redirect ? buyNow : atc;
        const label = btn.textContent; btn.classList.add('is-loading'); btn.textContent = T.strings.adding;
        try {
          const qty = Number(qtyInput ? qtyInput.value : 1) || 1;
          const item = { id: Number(idInput.value), quantity: qty };
          const props = {}; $$('[data-line-property]', form).forEach(p => { if (p.value) props[p.dataset.lineProperty] = p.value; });
          if (Object.keys(props).length) item.properties = props;
          const items = [item];
          const selOpt = bundleWrap && $('.bundle__option.is-selected', bundleWrap);
          const extras = selOpt ? $$('[data-bundle-extra]', selOpt) : [];
          if (extras.length) {
            item.quantity = 1;
            extras.forEach(ex => { const s = $('select[data-extra-variant]', ex); const vid = Number(s && s.value); if (vid) items.push({ id: vid, quantity: 1 }); });
          }
          await Cart.add(items);
          if (bundleQty > 1 && bundleCode) await applyDiscount(bundleCode);
          if (redirect) { location.href = T.cartUrl; return; }
          toast(T.strings.added);
          if (T.cartDrawer === false) location.href = T.cartUrl; else await Cart.refreshDrawer(true);
        } catch (err) { toast(err.message || 'No se pudo añadir'); }
        finally { btn.classList.remove('is-loading'); btn.textContent = label; }
      }
      form.addEventListener('submit', e => { e.preventDefault(); submit(false); });
      if (buyNow) buyNow.addEventListener('click', e => { e.preventDefault(); submit(true); });
      $$('[data-sticky-atc]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); submit(false); }));
      $$('.qty', form).forEach(q => { $$('button', q).forEach(b => b.addEventListener('click', () => { const i = $('input', q); i.value = Math.max(1, Number(i.value) + Number(b.dataset.delta)); })); });
      update();
    });

    // sticky add-to-cart en móvil
    const sticky = $('.sticky-atc'); const mainBtn = $('[data-add-to-cart]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 }).observe(mainBtn);
    }
    // quick add en tarjetas
    $$('[data-quick-add]').forEach(b => b.addEventListener('click', async e => {
      e.preventDefault(); const id = Number(b.dataset.quickAdd); if (!id) return;
      b.classList.add('is-loading');
      try { await Cart.add({ id, quantity: 1 }); toast(T.strings.added); await Cart.refreshDrawer(true); } catch (err) { toast(err.message); }
      finally { b.classList.remove('is-loading'); }
    }));
  }

  /* ---------- Galería ---------- */
  function initGallery() {
    $$('[data-gallery]').forEach(g => {
      const track = $('.carousel__track', g); const thumbs = $$('.gallery__thumb', g); const dots = $$('.gallery__dots span', g);
      if (!track) return;
      const setActive = i => { thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i)); dots.forEach((d, k) => d.classList.toggle('is-active', k === i)); };
      thumbs.forEach((t, i) => t.addEventListener('click', () => { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); setActive(i); }));
      track.addEventListener('scroll', () => { const i = Math.round(track.scrollLeft / track.clientWidth); setActive(i); }, { passive: true });
    });
  }

  /* ---------- Carruseles ---------- */
  function initCarousels() {
    $$('.carousel').forEach(c => {
      const track = $('.carousel__track', c); if (!track) return;
      const step = () => { const item = $('.carousel__item', track); return item ? item.getBoundingClientRect().width + 16 : track.clientWidth * .8; };
      const p = $('.carousel__nav--prev', c), n = $('.carousel__nav--next', c);
      if (p) p.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
      if (n) n.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
      if (c.dataset.autoplay) {
        let t = setInterval(() => { if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) track.scrollTo({ left: 0, behavior: 'smooth' }); else track.scrollBy({ left: step(), behavior: 'smooth' }); }, Number(c.dataset.autoplay) || 4000);
        c.addEventListener('pointerenter', () => clearInterval(t));
      }
    });
  }

  /* ---------- Vídeos ---------- */
  function initVideos() {
    const cards = $$('.video-card');
    cards.forEach(card => {
      const v = $('video', card); if (!v) return;
      v.muted = true; v.loop = true; v.playsInline = true;
      const play = $('.video-card__play', card); const mute = $('.video-card__mute', card);
      const toggle = () => { if (v.paused) { cards.forEach(o => { const ov = $('video', o); if (ov && ov !== v) { ov.pause(); o.classList.remove('is-playing'); } }); v.play(); card.classList.add('is-playing'); } else { v.pause(); card.classList.remove('is-playing'); } };
      if (play) play.addEventListener('click', e => { e.preventDefault(); toggle(); });
      v.addEventListener('click', toggle);
      if (mute) mute.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); v.muted = !v.muted; mute.classList.toggle('is-unmuted', !v.muted); });
      // autoplay silencioso al entrar en pantalla
      if ('IntersectionObserver' in window && card.dataset.autoplay !== 'false') {
        new IntersectionObserver(([en]) => { if (en.isIntersecting) { v.play().then(() => card.classList.add('is-playing')).catch(() => { }); } else { v.pause(); card.classList.remove('is-playing'); } }, { threshold: .6 }).observe(card);
      }
    });
  }

  /* ---------- Navegación móvil y búsqueda ---------- */
  function closeNav() { const n = $('#MobileNav'); if (n) { n.removeAttribute('open'); document.body.style.overflow = ''; } }
  function closeSearch() { const s = $('#SearchBar'); if (s) s.removeAttribute('open'); }
  function initNav() {
    const n = $('#MobileNav');
    $$('[data-nav-open]').forEach(b => b.addEventListener('click', () => { n.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }));
    $$('[data-nav-close]').forEach(b => b.addEventListener('click', closeNav));
    const s = $('#SearchBar');
    $$('[data-search-open]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); s.setAttribute('open', ''); setTimeout(() => $('input', s).focus(), 50); }));
    $$('[data-search-close]').forEach(b => b.addEventListener('click', closeSearch));
  }

  /* ---------- Búsqueda predictiva ---------- */
  function initPredictive() {
    const form = $('[data-predictive]'); if (!form) return;
    const input = $('[data-predictive-input]', form), box = $('[data-predictive-results]', form);
    let t, last = '';
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
      t = setTimeout(async () => {
        if (q === last) return; last = q;
        try {
          const r = await fetch(`${T.rootUrl.replace(/\/$/, '')}/search/suggest?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][prefix]=last&resources[options][unavailable_products]=last&section_id=predictive-search`);
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('.shopify-section') || doc.body;
          box.innerHTML = inner.innerHTML; box.hidden = !box.textContent.trim();
        } catch (e) { box.hidden = true; }
      }, 220);
    });
  }

  /* ---------- Pop-up de ventas recientes ---------- */
  function initSalesPopup() {
    const el = $('#SalesPopup'); if (!el) return;
    const clean = t => t.replace(/,\s*\]/g, ']');
    let items = []; try { items = JSON.parse(clean($('[data-sales-items]', el).textContent)); } catch (e) { }
    let names = []; try { names = JSON.parse(clean($('[data-sales-names]', el).textContent)); } catch (e) { }
    if (!items.length || !names.length) return;
    if (sessionStorage.getItem('co_popup_closed')) return;
    $('.sales-popup__close', el).addEventListener('click', () => { el.classList.remove('is-visible'); sessionStorage.setItem('co_popup_closed', '1'); });
    function show() {
      const it = items[Math.floor(Math.random() * items.length)]; const nm = names[Math.floor(Math.random() * names.length)];
      $('[data-sp-img]', el).src = it.image; $('[data-sp-name]', el).textContent = `${nm.name} de ${nm.city}`;
      $('[data-sp-product]', el).textContent = it.title; $('[data-sp-link]', el).href = it.url;
      $('[data-sp-time]', el).textContent = `hace ${2 + Math.floor(Math.random() * 40)} min`;
      el.classList.add('is-visible'); setTimeout(() => el.classList.remove('is-visible'), 6000);
    }
    setTimeout(() => { show(); setInterval(show, 22000 + Math.random() * 15000); }, 9000);
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) { $$('.reveal').forEach(e => e.classList.add('is-in')); return; }
    setTimeout(() => $$('.reveal').forEach(e => e.classList.add('is-in')), 2500);
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: .08 });
    $$('.reveal').forEach(e => io.observe(e));
  }

  /* ---------- Filtro rápido por chips en colección ---------- */
  function initFilterChips() {
    $$('[data-filter-chip]').forEach(ch => ch.addEventListener('click', e => {
      e.preventDefault(); const tag = ch.dataset.filterChip; const url = new URL(location);
      if (!tag) { location.href = url.pathname.split('/').slice(0, 3).join('/'); return; }
      location.href = ch.href;
    }));
  }

  document.addEventListener('DOMContentLoaded', () => {
    initDelivery(); initCountdowns(); initViewers(); initCartTriggers(); initProductForms();
    initGallery(); initCarousels(); initVideos(); initNav(); initPredictive(); initSalesPopup(); initReveal(); initFilterChips(); initUpsell();
  });
})();

/* ---------- Barra de anuncios: un mensaje cada vez ---------- */
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-announcement-rotator]').forEach(function(track){
      var items = track.querySelectorAll('.announcement-bar__item');
      if (items.length < 2) return;
      var i = 0; items[0].classList.add('is-active'); track.classList.add('is-ready');
      setInterval(function(){ items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 4000);
    });
  });
})();

/* ---------- Productos destacados: barra de progreso del carrusel ---------- */
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.fp__carousel').forEach(function(c){
      var track = c.querySelector('.carousel__track'), bar = c.querySelector('.fp__progress');
      if (!track || !bar) return;
      var update = function(){
        var max = track.scrollWidth - track.clientWidth;
        var w = Math.max(15, Math.min(100, track.clientWidth / track.scrollWidth * 100));
        var pos = max > 0 ? track.scrollLeft / max : 0;
        bar.style.setProperty('--fp-w', w + '%');
        bar.style.setProperty('--fp-x', (pos * (100 - w) / w * 100) + '%');
        bar.style.display = max > 4 ? '' : 'none';
      };
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      // pausa el autoplay también al tocar en móvil
      track.addEventListener('touchstart', function(){ c.dispatchEvent(new Event('pointerenter')); }, { passive: true });
    });
  });
})();

/* ---------- Carrito Club Origins: seguro de envío, nota, upsell, descuentos ---------- */
(function(){
  var T = window.theme || {};
  var root = (T.rootUrl || '/').replace(/\/$/, '');
  function post(url, body){ return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function(r){ return r.json(); }); }
  var timerInt = null;

  window.coCartEnhance = function(scope){
    var cart = (scope || document).querySelector('[data-co-cart]');
    if (!cart) return;

    // si solo queda el seguro de envío, se quita solo
    var orphan = cart.getAttribute('data-protection-orphan');
    if (orphan) { post((T.cartChangeUrl || '/cart/change') + '.js', { id: orphan, quantity: 0 }).then(function(){ window.Cart && Cart.refreshDrawer(false); }); return; }

    // aplica el código del pack (2 o 3 camisetas) para que el descuento salga en el checkout
    var code = cart.getAttribute('data-bundle-code');
    try {
      if (code && sessionStorage.getItem('co_code') !== code) {
        fetch(root + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(T.cartUrl || '/cart'), { credentials: 'same-origin' }).catch(function(){});
        sessionStorage.setItem('co_code', code);
      }
    } catch (e) {}

    // seguro de envío
    cart.querySelectorAll('[data-protection-toggle]').forEach(function(t){
      if (t._b) return; t._b = true;
      t.addEventListener('change', function(){
        t.disabled = true;
        var p = t.checked
          ? post((T.cartAddUrl || '/cart/add') + '.js', { items: [{ id: Number(t.dataset.variant), quantity: 1 }] })
          : post((T.cartChangeUrl || '/cart/change') + '.js', { id: t.dataset.key, quantity: 0 });
        p.then(function(){ return window.Cart && Cart.refreshDrawer(false); }).catch(function(){ t.disabled = false; });
      });
    });

    // instrucciones especiales
    cart.querySelectorAll('[data-cart-note]').forEach(function(n){
      if (n._b) return; n._b = true; var to;
      n.addEventListener('input', function(){ clearTimeout(to); to = setTimeout(function(){ post((T.cartUpdateUrl || '/cart/update') + '.js', { note: n.value }); }, 500); });
    });

    // carrusel del upsell
    cart.querySelectorAll('[data-co-upsell]').forEach(function(u){
      var tr = u.querySelector('[data-upsell-track]'); if (!tr) return;
      var go = function(d){ tr.scrollBy({ left: d * tr.clientWidth, behavior: 'smooth' }); };
      var p = u.querySelector('[data-upsell-prev]'), n = u.querySelector('[data-upsell-next]');
      if (p && !p._b) { p._b = true; p.addEventListener('click', function(){ go(-1); }); }
      if (n && !n._b) { n._b = true; n.addEventListener('click', function(){ go(1); }); }
    });

    // temporizador (opcional, desactivado por defecto)
    var tm = cart.querySelector('[data-cart-timer]');
    clearInterval(timerInt);
    if (tm) {
      var clock = tm.querySelector('[data-cart-timer-clock]');
      var end;
      try { end = Number(sessionStorage.getItem('co_timer')); } catch (e) {}
      if (!end || end < Date.now()) { end = Date.now() + Number(tm.dataset.cartTimer || 10) * 60000; try { sessionStorage.setItem('co_timer', end); } catch (e) {} }
      var tick = function(){ var s = Math.max(0, Math.round((end - Date.now()) / 1000)); clock.textContent = Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); if (!s) clearInterval(timerInt); };
      tick(); timerInt = setInterval(tick, 1000);
    }
  };

  /* ---------- Ficha: personalización ---------- */
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-perso]').forEach(function(box){
      box.querySelectorAll('input[data-line-property]').forEach(function(i){
        i.addEventListener('input', function(){
          var v = i.value.toUpperCase();
          if (v !== i.value) i.value = v;
          box.classList.toggle('is-filled', Array.prototype.some.call(box.querySelectorAll('input[data-line-property]'), function(x){ return x.value; }));
        });
      });
      var modal = box.querySelector('[data-perso-modal]');
      var open = box.querySelector('[data-perso-open]');
      if (modal && open) {
        open.addEventListener('click', function(){ if (modal.showModal) modal.showModal(); else modal.setAttribute('open', ''); });
        modal.querySelector('[data-perso-close]').addEventListener('click', function(){ modal.close ? modal.close() : modal.removeAttribute('open'); });
        modal.addEventListener('click', function(e){ if (e.target === modal) modal.close(); });
      }
      var cd = box.querySelector('[data-perso-countdown]');
      if (cd) {
        var t = function(){ var n = new Date(), m = new Date(n); m.setHours(24, 0, 0, 0); var s = Math.floor((m - n) / 1000);
          cd.textContent = [Math.floor(s / 3600), Math.floor(s % 3600 / 60), s % 60].map(function(x){ return String(x).padStart(2, '0'); }).join(':'); };
        t(); setInterval(t, 1000);
      }
    });
  });
})();


/* ---------- Pack combinable: elegir otra camiseta y talla para #2 / #3 ---------- */
(function(){
  function money(c){ return window.formatMoney ? window.formatMoney(c) : (c/100).toFixed(2) + ' €'; }
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-bundle]').forEach(function(bundle){
      var dataEl = bundle.querySelector('[data-mix-products]'); if (!dataEl) return;
      var list; try { list = JSON.parse(dataEl.textContent).filter(function(p){ return p.id && p.a; }); } catch (e) { return; }
      var scope = bundle.closest('[data-product]') || document;
      var pjEl = scope.querySelector('[data-product-json]'); if (!pjEl) return;
      var main = JSON.parse(pjEl.textContent);
      var form = scope.querySelector('form[data-product-form]');
      var byId = {}; list.forEach(function(p){ byId[p.id] = p; });
      if (!byId[main.id]) { byId[main.id] = { id: main.id, t: main.title, img: '', v: main.variants.map(function(v){ return { id: v.id, t: v.title, a: v.available, p: v.price, c: v.compare_at_price || 0 }; }) }; }
      var panel = bundle.querySelector('[data-mix-panel]'), grid = bundle.querySelector('[data-mix-grid]');
      var activeRow = null;

      function currentMain(){ var id = Number((form && form.querySelector('input[name="id"]') || {}).value); return main.variants.filter(function(v){ return v.id === id; })[0] || main.variants[0]; }
      function fillSizes(sel, variants, prefer){
        sel.innerHTML = '';
        variants.forEach(function(v){ var o = document.createElement('option'); o.value = v.id; o.textContent = String(v.t).toUpperCase() + (v.a ? '' : ' — AGOTADO'); if (!v.a) o.disabled = true; sel.appendChild(o); });
        var match = variants.filter(function(v){ return v.a && prefer && String(v.t).toUpperCase() === String(prefer).toUpperCase(); })[0] || variants.filter(function(v){ return v.a; })[0];
        if (match) sel.value = match.id;
      }
      // fila #1: tallas sincronizadas con los botones de talla de arriba
      bundle.querySelectorAll('[data-mix-main-size]').forEach(function(sel){
        fillSizes(sel, byId[main.id].v, currentMain().title);
        sel.addEventListener('change', function(){
          var v = main.variants.filter(function(x){ return x.id === Number(sel.value); })[0]; if (!v || !form) return;
          v.options.forEach(function(val, i){ var fs = form.querySelector('fieldset[data-option-index="' + i + '"]'); if (!fs) return;
            Array.prototype.forEach.call(fs.querySelectorAll('input'), function(r){ if (r.value === val && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); } }); });
        });
      });
      bundle.querySelectorAll('[data-bundle-extra]').forEach(function(row){
        fillSizes(row.querySelector('[data-extra-variant]'), byId[main.id].v, currentMain().title);
        var img = row.querySelector('.co-mix__pick img'); var mImg = bundle.querySelector('[data-mix-main] img'); if (img && mImg) img.src = mImg.src;
      });

      // selector de producto con fotos (todos los productos de la tienda)
      function addOpt(p){
        var b = document.createElement('button'); b.type = 'button'; b.className = 'co-mix__opt'; b.title = p.t; b.setAttribute('aria-label', p.t); b.dataset.id = p.id; b.dataset.name = String(p.t).toLowerCase();
        b.innerHTML = '<img src="' + p.img + '" alt="" loading="lazy" width="80" height="80">';
        b.addEventListener('click', function(e){ e.stopPropagation(); if (!activeRow) return;
          activeRow.dataset.product = p.id; activeRow.querySelector('.co-mix__pick img').src = p.img;
          var prevSize = activeRow.querySelector('[data-extra-variant] option:checked');
          fillSizes(activeRow.querySelector('[data-extra-variant]'), p.v, prevSize ? prevSize.textContent : currentMain().title);
          close(); recalc(); });
        grid.appendChild(b);
      }
      list.forEach(addOpt);
      // buscador dentro del selector
      var search = document.createElement('input');
      search.type = 'search'; search.className = 'co-mix__search'; search.placeholder = 'Buscar camiseta…'; search.setAttribute('aria-label', 'Buscar camiseta');
      search.addEventListener('click', function(e){ e.stopPropagation(); });
      search.addEventListener('input', function(){ var q = search.value.trim().toLowerCase();
        Array.prototype.forEach.call(grid.children, function(c){ c.hidden = q && c.dataset.name.indexOf(q) === -1; }); });
      panel.insertBefore(search, grid);
      // carga el catálogo completo (sin límite de 50) desde /products.json
      var protectId = Number(dataEl.dataset.protect || 0);
      var rootUrl = ((window.theme && window.theme.rootUrl) || '/').replace(/\/?$/, '/');
      function thumb(src){ return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160' : ''; }
      function cents(x){ return Math.round(parseFloat(x || 0) * 100); }
      (function loadPage(page){
        fetch(rootUrl + 'products.json?limit=250&page=' + page, { headers: { Accept: 'application/json' } })
          .then(function(r){ return r.ok ? r.json() : { products: [] }; })
          .then(function(d){
            var ps = (d && d.products) || [];
            ps.forEach(function(p){
              if (byId[p.id] || p.id === protectId) return;
              var vs = (p.variants || []).map(function(v){ return { id: v.id, t: v.title, a: v.available !== false, p: cents(v.price), c: cents(v.compare_at_price) }; });
              if (!vs.some(function(v){ return v.a; })) return;
              var img = thumb(p.images && p.images[0] && p.images[0].src);
              var item = { id: p.id, t: p.title, img: img, a: true, v: vs };
              byId[p.id] = item; list.push(item); addOpt(item);
            });
            if (ps.length === 250 && page < 20) loadPage(page + 1);
          }).catch(function(){});
      })(1);
      function close(){ panel.hidden = true; if (activeRow) activeRow.classList.remove('is-picking'); activeRow = null; }
      bundle.querySelectorAll('[data-mix-open]').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.stopPropagation();
          var row = btn.closest('[data-bundle-extra]');
          var opt = row.closest('.bundle__option'); if (!opt.classList.contains('is-selected')) opt.click();
          if (activeRow === row) { close(); return; }
          close(); activeRow = row; row.classList.add('is-picking');
          row.after(panel); panel.hidden = false;
          Array.prototype.forEach.call(grid.children, function(c){ c.classList.toggle('is-current', c.dataset.id === row.dataset.product); });
        });
      });
      document.addEventListener('click', function(e){ if (!panel.hidden && !panel.contains(e.target)) close(); });
      bundle.querySelectorAll('.co-mix select').forEach(function(s){ s.addEventListener('click', function(e){ e.stopPropagation(); }); s.addEventListener('change', recalc); });

      // precios del pack con los modelos elegidos
      function priceOf(vid){ for (var k in byId) { var v = byId[k].v.filter(function(x){ return x.id === vid; })[0]; if (v) return v; } return null; }
      function recalc(){
        bundle.querySelectorAll('.bundle__option').forEach(function(opt){
          var extras = opt.querySelectorAll('[data-bundle-extra]'); if (!extras.length) return;
          var disc = Number(opt.dataset.discount || 0), m = currentMain();
          var base = m.price, cmp = (m.compare_at_price && m.compare_at_price > m.price) ? m.compare_at_price : m.price;
          Array.prototype.forEach.call(extras, function(ex){ var v = priceOf(Number(ex.querySelector('[data-extra-variant]').value)); if (v) { base += v.p; cmp += (v.c && v.c > v.p) ? v.c : v.p; } });
          var total = Math.round(base * (1 - disc / 100)), q = extras.length + 1;
          var t = opt.querySelector('[data-bundle-total]'); if (t) t.textContent = money(total);
          var c = opt.querySelector('[data-bundle-compare]'); if (c) c.textContent = cmp > total ? money(cmp) : '';
          var sv = opt.querySelector('[data-bundle-save]'); if (sv) sv.textContent = disc ? 'Ahorras ' + money(base - total) + ' · ' + money(Math.round(total / q)) + '/ud' : money(Math.round(total / q)) + '/ud';
        });
      }
      if (form) form.addEventListener('change', function(e){
        if (e.target.closest('.co-mix')) return;
        setTimeout(function(){ var m = currentMain(); bundle.querySelectorAll('[data-mix-main-size]').forEach(function(s){ s.value = m.id; }); recalc(); }, 0);
      });
      setTimeout(recalc, 0);
    });
  });
})();

/* ---------- Sección Mundial: puntos de página y favoritos ---------- */
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.wc__carousel').forEach(function(c){
      var tr = c.querySelector('.wc__track'), dots = c.querySelector('[data-wc-dots]'); if (!tr || !dots) return;
      function pages(){ return Math.max(1, Math.ceil(tr.scrollWidth / tr.clientWidth - 0.08)); }
      function build(){
        var n = pages(); dots.innerHTML = '';
        if (n < 2) return;
        for (var i = 0; i < n; i++) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Página ' + (i + 1));
          (function(i){ b.addEventListener('click', function(){ c.dispatchEvent(new Event('pointerenter')); tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); }); })(i);
          dots.appendChild(b); }
        update();
      }
      function update(){ var n = dots.children.length; if (!n) return; var max = tr.scrollWidth - tr.clientWidth; var i = max > 0 ? Math.round(tr.scrollLeft / max * (n - 1)) : 0;
        Array.prototype.forEach.call(dots.children, function(d, k){ d.classList.toggle('is-active', k === i); }); }
      tr.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', build); build();
      tr.addEventListener('touchstart', function(){ c.dispatchEvent(new Event('pointerenter')); }, { passive: true });
    });
    var KEY = 'co_wishlist', list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    document.querySelectorAll('[data-wish]').forEach(function(b){
      var id = b.dataset.wish; b.setAttribute('aria-pressed', list.indexOf(id) > -1 ? 'true' : 'false');
      b.addEventListener('click', function(e){ e.preventDefault();
        var i = list.indexOf(id); if (i > -1) list.splice(i, 1); else list.push(id);
        try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
        document.querySelectorAll('[data-wish="' + id + '"]').forEach(function(x){ x.setAttribute('aria-pressed', i > -1 ? 'false' : 'true'); });
      });
    });
  });
})();
